<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout justify-center wrap v-if="overall">
      <v-flex xs12>
        <v-card outlined>
          <v-card-text>
            <v-layout justify-start wrap pt-5>
              <v-flex xs11 sm11 md10 lg11 xl11>
                <span
                  style="
                    color: #000000;
                    font-family: nunitosansbold;
                    font-size: 18px;
                  "
                  >Overall Performance</span
                >
              </v-flex>
              <!-- <v-flex xs11 sm6 md2 lg1 xl1>
                <v-card max-height="30" outlined>
                  <v-layout justify-end wrap>
                    <v-flex xs9 sm9 md9 lg9 xl9 text-center>
                      <span
                        style="
                          color: #000000;
                          font-family: nunitosanssemibold;
                          font-size: 12px;
                        "
                        >FILTER</span
                      >
                    </v-flex>
                    <v-flex xs3 text-center>
                      <v-icon
                        style="
                          color: #555555;
                          font-family: nunitosansregular;
                          font-size: 14px;
                        "
                        >mdi-plus</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex> -->
            </v-layout>
            <v-layout justify-center wrap py-5>
              <v-flex xs12>
                <v-select
                  v-model="val"
                  style="color: #000000; font-family: nunitosanssemibold"
                  color="#000000"
                  label="Select Category"
                  :items="items"
                  item-text="name"
                  item-value="value"
                  solo
                ></v-select>
              </v-flex>
              <v-layout justify-start wrap v-if="val == 'Particular Subject'">
                <v-flex xs12>
                  <span
                    style="
                      color: #000000;
                      font-family: nunitosanssemibold;
                      font-size: 18px;
                    "
                    >Particular Subject</span
                  ><br />
                  <span
                    style="
                      color: #4e4e4e;
                      font-family: nunitosansregular;
                      font-size: 12px;
                    "
                    >Select Subject</span
                  >
                </v-flex>
                <v-flex>
                  <v-chip-group
                    active-class="Light blue white--text"
                    column
                    class="ma-1"
                    small
                    outlined
                    v-model="selection"
                    rounded
                  >
                    <v-chip
                      v-for="item in subjectArray"
                      :value="item.subject._id"
                      :key="item.subject._id"
                    >
                      {{ item.subject.subjectName }}
                    </v-chip>
                  </v-chip-group>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap v-if="val != 'Particular Subject' && val != 'All' && val !='Gender'">
                <v-flex xs12>
                  <span
                    style="
                      color: #000000;
                      font-family: nunitosanssemibold;
                      font-size: 18px;
                    "
                    >Test</span
                  ><br />
                  <span
                    style="
                      color: #4e4e4e;
                      font-family: nunitosansregular;
                      font-size: 12px;
                    "
                    >Select Exam</span
                  >
                </v-flex>
                <v-flex>
                  <v-chip-group
                    active-class="Light blue white--text"
                    column
                    class="ma-1"
                    small
                    outlined
                    v-model="selection2"
                    rounded
                  >
                    <v-chip
                      v-for="item in examArray"
                      :value="item._id"
                      :key="item._id"
                    >
                      {{ item.ExamName }}
                    </v-chip>
                  </v-chip-group>
                </v-flex>
              </v-layout>
              <v-layout
                justify-start
                wrap
                v-if="val != 'Particular Subject' && val != 'All' && val !='Test'"
              >
                <v-flex xs12>
                  <span
                    style="
                      color: #000000;
                      font-family: nunitosanssemibold;
                      font-size: 18px;
                    "
                    >Gender</span
                  ><br />
                  <span
                    style="
                      color: #4e4e4e;
                      font-family: nunitosansregular;
                      font-size: 12px;
                    "
                    >Select Gender</span
                  >
                </v-flex>
                <v-flex>
                  <v-chip-group
                    active-class="Light blue white--text"
                    column
                    class="ma-1"
                    small
                    outlined
                    v-model="selection1"
                    rounded
                  >
                    <v-chip 
                    :value="item.name" v-for="item in itemArray" :key="item.name">
                      {{ String(item.name) }}
                    </v-chip>
                  </v-chip-group>
                </v-flex>
              </v-layout>
              <v-flex xs12>
                <span
                  v-if="val != 'Particular Subject' && val != 'Gender' && val !='Test'"
                  style="
                    color: #000000;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >All Subject</span
                ><br />
                <span
                  style="
                    color: #4e4e4e;
                    font-family: nunitosansregular;
                    font-size: 12px;
                  "
                  >Number of Students</span
                >
              </v-flex>
              <v-flex xs12>
                <div id="chart" v-if="flag">
                  <apexchart
                    type="line"
                    height="350"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </v-flex>
            </v-layout>
            <v-layout justify-center wrap>
              <v-flex xs12>
                <v-layout justify-start wrap>
                  <v-flex xs12 sm12 md2 lg2 pa-2 text-center>
                    <v-card outlined>
                      <v-card-text>
                        <span
                          style="
                            color: #4e4e4e;
                            font-family: nunitosansregular;
                            font-size: 12px;
                          "
                          >Min:
                        </span>
                        <span
                          v-if="overall"
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >{{ overall.minCGPA }}</span
                        >
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm12 md3 lg2 pa-2 text-center>
                    <v-card outlined>
                      <v-card-text>
                        <span
                          style="
                            color: #4e4e4e;
                            font-family: nunitosansregular;
                            font-size: 12px;
                          "
                          >Avg:
                        </span>
                        <span
                          v-if="overall"
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >{{ overall.avgCGPA }}</span
                        >
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm12 md3 lg2 pa-2 text-center>
                    <v-card outlined>
                      <v-card-text>
                        <span
                          style="
                            color: #4e4e4e;
                            font-family: nunitosansregular;
                            font-size: 12px;
                          "
                          >Max:
                        </span>
                        <span
                          v-if="overall"
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >{{ overall.maxCGPA }}</span
                        >
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm12 md3 lg2 pa-2 text-center>
                    <v-card outlined>
                      <v-card-text>
                        <span
                          style="
                            color: #4e4e4e;
                            font-family: nunitosansregular;
                            font-size: 12px;
                          "
                          >Student:
                        </span>
                        <span
                          v-if="overall"
                          style="
                            color: #000000;
                            font-family: nunitosanssemibold;
                            font-size: 12px;
                          "
                          >{{ overall.thisStudentCGPA }}</span
                        >
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <table id="customers" class="hidden-sm-and-down">
              <tr>
                <td style="color: #8474f7; font-family: nunitosansregular">
                  PERCENTILE
                </td>
                <!-- <td style="color: #4d4d4d; font-family: nunitosanslight">0</td> -->
                <td
                  v-for="(item, i) in percentileTable"
                  :key="i"
                  style="color: #4d4d4d; font-family: nunitosanslight"
                >
                  {{ item.percentile }}
                </td>
              </tr>
              <tr>
                <td style="color: #8474f7; font-family: nunitosansregular">
                  CGPA
                </td>
                <!-- <td></td> -->
                <td
                  v-for="(item, i) in percentileTable"
                  :key="i"
                  style="color: #000000; font-family: nunitosanssemibold"
                >
                  {{ item.CGPA }}
                </td>
              </tr>
            </table>
            <v-layout justify-center wrap class="hidden-md-and-up">
              <v-flex xs6 text-left>
                <span style="color: #8474f7; font-family: nunitosansregular">
                  PERCENTILE</span
                >
                <v-layout
                  justify-center
                  wrap
                  v-for="(item, i) in percentileTable"
                  :key="i"
                >
                  <span style="color: #4d4d4d; font-family: nunitosanslight">
                    {{ item.percentile }}</span
                  >
                </v-layout>
              </v-flex>
              <v-flex xs6 text-center>
                <span style="color: #8474f7; font-family: nunitosansregular">
                  CGPA</span
                >
                <v-layout
                  justify-center
                  wrap
                  v-for="(item, i) in percentileTable"
                  :key="i"
                >
                  <span style="color: #000000; font-family: nunitosanssemibold">
                    {{ item.CGPA }}</span
                  >
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage","student"],
  data() {
    return {
      overall: [],
      selection: null,
      selection1: null,
      selection2: null,
      graph: [],
      percentileTable: [],
      val: "",
      items: ["All", "Particular Subject", "Gender", "Test"],
      itemArray: [{ name: "All" }, { name: "Male" }, { name: "Female" }],
      flag: false,
      subjectArray: [],
      examArray:[],
      appLoading: false,
      subject: "",
      series: [
        {
          name: "Frequency",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        yaxis: {
          // categories1: [],
          // formatter: function (val) {
          //     return val;
          //   },
          title: {
            text: "FREQUENCY OF STUDENTS",
            style: {
              fontSize: "14px",
              fontFamily: "nunitosansregular",
              colors: ["#8474F7"],
            },
          },
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanssemibold",
              colors: ["#9A9A9A"],
            },
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "CGPA",
            style: {
              fontSize: "14px",
              fontFamily: "nunitosansregular",
              colors: ["#8474F7"],
            },
          },
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanslight",
              colors: ["#4D4D4D"],
            },
          },
        },
      },
    };
  },
  watch: {
    subject() {
      this.getOverall();
    },
    selection() {
      this.getOverall();
    },
    selection1() {
      this.getOverall();
    },
     selection2() {
      this.getOverall();
    },
    val() {
      if (this.val == "All") {
        this.getOverall();
      }
    },
  },
  mounted() {
    this.val = "All";
    this.getOverall();
    this.getSubject();
    this.getExam()
  },
  methods: {
    getOverall() {
      this.appLoading = true;
      this.flag = false;
      this.series[0].data = [];
      this.chartOptions.xaxis.categories = [];
      axios({
        method: "GET",
        url: "/exam/mark/classwiselastexam",
        params: {
          classid: this.storage._id,
          subject: this.selection,
          gender: this.selection1,
          student:this.student
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.overall = response.data.data;
          this.graph = response.data.data.grpah;
          this.percentileTable = response.data.data.percentileTable;
          this.chartOptions.xaxis.categories = [];
          for (var i = 0; i < this.graph.length; i++) {
            this.chartOptions.xaxis.categories.push(
              parseFloat(this.graph[i].CGPA).toFixed(1)
            );
            this.series[0].data.push(this.graph[i].frequency);
          }
          this.flag = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSubject() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/class/subject/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          classid: this.storage._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subjectArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
       getExam() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/standard/exam/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
         params: {
          standard: this.storage.standard,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.examArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
#customers td {
  /* border: 1px solid #ddd; */
  padding: 8px;
}
#customers th {
  border-top: 2px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
</style>